import React from "react";
import Button, { EButtonColors } from "../../components/Button/Button";
import styles from "./Thanks.module.css";
import banner from "../../assets/thanks-banner.png";
import leftCloud from "../../assets/left-cloud.png";
import rightCloud from "../../assets/right-cloud.png";

interface IThanks {
  onGetStarted: () => void;
  // Default text message
  title?: string;
  // custom style
  className?: string;
}

const Thanks: React.FC<IThanks> = ({
  onGetStarted,
  title = "Thank you for your order!",
  className,
}) => (
  <div className={`${styles.container} ${className}`}>
    <div className={styles.bannerImage} />
    <h1 className={styles.title}>{title}</h1>
    <p className={styles.description}>
      Click <span>Get Started</span> below to continue.
      <br/>
      {"(We have sent you a confirmation email with your credentials.)"}
    </p>

    <Button
      className={styles.getStartedBtn}
      text="Get Started"
      color={EButtonColors.Green}
      width={271}
      onClick={onGetStarted}
    />
    <div className={styles.leftCloud} />
    <div className={styles.rightCloud} />
  </div>
);

export default Thanks;
